import AxiosServices from "./AxiosService";

const Auth = new AxiosServices();


class AnouncementsService {

    AddAnouncements = async (announcements) => {
        return Auth.post('/announcements', announcements)
    };

    GetById(announcementId) {
        return Auth.get(`/announcements/${announcementId}`)
    }
    UpdateByID(announcements, announcementId){
        return Auth.put(`/announcements/${announcementId}`, announcements)
    }

    DeleteById(announcementId) {
        return Auth.delete(`/announcements/${announcementId}`)
    }

    GetAllAnouncements(page = 1, limit = 10) {
        const queryParams = new URLSearchParams();
        if (page) queryParams.append('page', page);
        if (limit) queryParams.append('limit', limit);

        return Auth.get(`/announcements${queryParams.toString() ? `?${queryParams.toString()}` : ''}`);
    }

    GetCourseAnouncements(CourseID, page = 1, limit = 1) {
        const queryParams = new URLSearchParams();
        if (page) queryParams.append('page', page);
        if (limit) queryParams.append('limit', limit);

        return Auth.get(`/announcements/courses/${CourseID}${queryParams.toString() ? `?${queryParams.toString()}` : ''}`);
    }

    GetPublicAnouncements(page = 1, limit = 1) {
        const queryParams = new URLSearchParams();
        if (page) queryParams.append('page', page);
        if (limit) queryParams.append('limit', limit);

        return Auth.get(`/announcements/public${queryParams.toString() ? `?${queryParams.toString()}` : ''}`);
    }

}

export default AnouncementsService

